import React, { useState, useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import usePageSEO from '../../hooks/usePageSEO'
import axios from "axios";
import Loader from '../../components/Loader'

const Essence = () => {

  const [loading, setLoading] = useState(true);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const siteUrl = process.env.REACT_APP_BACKEND_URL;
  const [essenceWidget, setEssenceWidget] = useState(null)
  const [metaTitle, setMetaTitle] = useState('')
  const [metaDescription, setMetaDescription] = useState('')
  const [essenceData, setEssenceData] = useState([])

  const apiUrl = apiBaseUrl+`aboutpage`;



  const fetchPagedata = async() => {
    try{
    return await axios.get(apiUrl).then((res) => {
      setMetaTitle(res.data.page.meta_title);
      setMetaDescription(res.data.page.meta_description);
      setEssenceWidget(res.data.essencewidget)
      setEssenceData(res.data.parentessencewidget)
    });
    }catch(err){
      console.log(err);
    }
  };  

  useEffect(() => {
    setTimeout(() => {
      fetchPagedata()
        setLoading(false);
    }, 2000);
  }, []);

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  })  

  return (
    <>
    <Header/>

    { loading && (<Loader />)}

    <div id="essence" className="container vertical-gap"><hr /></div>

    <section className="section-content-block wow fadeInDown" data-wow-duration="1s">

      <div className="container wow fadeIn">
          
        <div className="row">
            <div className="col-md-offset-2 col-md-8 col-sm-12 text-center about-us-intro">    
                <p className="blue">{essenceWidget?.name}</p>
                <p className="our-experience">{essenceWidget?.heading}</p>
                <div className="about-us-intro col-lg-offset-1 col-lg-10 col-sm-12">
                  {essenceWidget?.description}
                </div>                            
            </div>
        </div>

        <div className="row text-center margin-top-32 solar-advantage">
          <ul>
              {essenceData.map((item, index) => {
                return (          
                  <li className="" key={index}> 
                      <div className="highlight-box">
                        <div className="icon-box"> 
                          <img src={`${siteUrl}${item?.image}`} alt={item?.name} />
                        </div>
                        <p className="heading">{item?.heading}</p>
                        <p>{item?.description}</p>
                      </div>
                  </li>
                );
            })}
        </ul>
        </div>

      </div>       
    </section>  

    <Footer/>
    </>

  )
}

export default Essence